import { REGEX_VALID_EMAIL } from '@/constants/constants';


export default {
  name: 'Input',

  props: {
    value: String,
    icon: String,
    placeholder: String,
    type: String,
    required: Boolean,
    title: String,
    autocomplete: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    onChangeInput() {
      this.isError = false;
      this.$emit('onChange', this.inputValue);
      this.$emit('input', this.inputValue);
    },

    onEnterClick() {
      this.$emit('onEnterClick');
    },

    validate() {
      if (this.type === 'email' && this.inputValue) {
        if (!this.inputValue.match(REGEX_VALID_EMAIL)) {
          this.errorMessage = 'incorrect_email';
          this.isError = true;
        }
      }

      if (this.required && !this.inputValue) {
        this.errorMessage = 'cant_be_empty';
        this.isError = true;
      }

      return !this.isError;
    },

    changeVisibility() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    },
  },

  data() {
    return {
      inputValue: this.value,
      isInputDisabled: this.disabled,
      inputType: this.type || 'text',
      isError: false,
      errorMessage: '',
      inputIcon: this.icon || false,
    };
  },
};
